import * as React from 'react'
import {slide as MenuMobile} from 'react-burger-menu'
import {connect} from 'react-redux'
import * as gifActions from "../../actions/gifAction";
import {IMenuLeftemobileProps} from "./IMenuLeftemobileProps";
import {IMenuLeftemobileState} from "./IMenuLeftemobileState";
import MenuLeftComponent from "../menuLeftComponent/MenuLeftComponent";
import * as actions from "../../actions/modalActions";
import * as action from "../../actions/categoryAction";
import {withRouter} from "react-router-dom";
import {Menu} from 'semantic-ui-react'

class MenuLeftemobile extends React.Component<IMenuLeftemobileProps, IMenuLeftemobileState> {


    constructor(props: IMenuLeftemobileProps) {
        super(props);
        this.state = {
            categories: [],
            loading: true
        }

    }


    componentDidMount() {
        let categorie = []
        this.props.fetchCategories(() => {

            if (this.props.categories && this.props.categories.length > 0) {
                this.props.categories.map((item, index) => {
                    if (index !== 0)
                        categorie.push(item)
                })
                this.setState({
                    categories: categorie.sort((a, b) => {
                        return parseInt(a.priority) - parseInt(b.priority)
                    }),
                    loading: false
                }, () => {
                    console.log(this.state.categories)
                })
            }
        })
    }

    fetchCategory = (cat, name) => {

        this.props.fetchTagsByCategory(cat)
            .then((tags) => {
                this.props.handleSearch(tags, () => {
                    this.props.history.push({
                        pathname: '/search',
                        state: name
                    })
                })
            })
    }

    render(): React.ReactNode {
        console.log(this.state)
        return (
            <div>
                <MenuMobile
                    pageWrapId={'page-wrap'} outerContainerId={'outer-container'}
                    onStateChange={(res) => {
                        this.props.openSideBar(res.isOpen)
                    }}
                    left isOpen={this.props.openSide}>
                    {this.props.authenticated ?
                        <div>
                            <div>
                                <MenuLeftComponent nodrop={true}/>
                            </div>
                            <h3>CATEGORIES</h3>





                            {
                                this.state.categories && this.state.categories.length > 0 ?


                                        <Menu inverted vertical>

                                        {
                                            this.state.categories.slice(0, 6).map((cat, index) => (

                                                <Menu.Item key={index} onClick={() => this.fetchCategory(cat.id, cat.name)}>
                                                    {cat.name}
                                                </Menu.Item>
                                            ))
                                        }
                                        </Menu>

                                    : null
                            }
                        </div>
                        : null
                    }
                </MenuMobile>
            </div>
        )
    }
}


function mapsStateToProps(state) {
    return {
        openSide: state.toast.openSide,
        authenticated: state.auth.authenticated,
        categories: state.categories.categories
    };
}

const mapDispatchToProps = (dispatch: any, ownProps: IMenuLeftemobileProps) => {
    return {
        openSideBar: (open) => dispatch(actions.sideBar(open)),
        fetchCategories: (cb) => dispatch(action.fetchCategories(cb)),
        fetchTagsByCategory: (cat) => dispatch(action.fetchTagsByCategory(cat)),
        handleSearch: (text, cb) => dispatch(gifActions.search(text, cb))
    }
}

export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(MenuLeftemobile))



// WEBPACK FOOTER //
// ./src/components/menuLeftMobile/MenuLeftemobile.tsx